// extracted by mini-css-extract-plugin
module.exports = {"replace":"order-details_replace__wo0r_","icon":"order-details_icon__iPcj_","link-btn":"order-details_link-btn__p5_ha","link-btn-icon":"order-details_link-btn-icon__r06vp"};